import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Footer from '../components/Footer'
import favicon from './images/favicon.png'
import faviconIco from './images/favicon.ico'
import faviconApple from './images/apple-touch-icon.png'
import faviconAndroid from './images/favicon-192x192.png'

export default ({ children, data }) => (
  <div>
    <Helmet>
      <title>Matt Patterson - Software Developer in Melbourne, Australia</title>
      <meta name="title" content="Matt Patterson - Software Developer in Melbourne, Australia" />
      <meta name="description" content="Matt Patterson - A Software Developer based in Melbourne, Australia. Loves music, gigs and coffee. I enjoy writing Ruby but branch into all things PHP, Javascript and React." />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="Matt Patterson" />
      <meta property="og:image" content={faviconAndroid} />
      <meta property="og:url" content="https://mattpatterson.xyz" />
      <meta property="og:site_name" content="Matt Patterson" />
      <meta property="og:description" content="Matt Patterson - A Software Developer based in Melbourne, Australia. Loves music, gigs and coffee. I enjoy writing Ruby but branch into all things PHP, Javascript and React." />
      <meta property="og:locale" content="en" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Matt Patterson" />
      <meta name="twitter:image" content={faviconAndroid} />
      <meta name="twitter:description" content="Matt Patterson - A Software Developer based in Melbourne, Australia. Loves music, gigs and coffee. I enjoy writing Ruby but branch into all things PHP, Javascript and React." />

      <link rel="shortcut icon" href={faviconIco} />
      <link rel="icon" type="image/png" href={faviconAndroid} sizes="192x192" />
      <link rel="apple-touch-icon" sizes="180x180" href={faviconApple} />
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
    </Helmet>

    {children()}

    <Footer />
  </div>
)


export const query = graphql`
  query SiteMetadataQuery {
    site {
      siteMetadata {
        title
        description
        keywords
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js